import axios from 'axios';
import { MESSAGES } from '../utils/constants';
export interface ResponseError {
  status?: number;
  message: string;
}

const getMessage = (status?: number, message?: string): string => {
  switch (status) {
    case 403:
      return message || MESSAGES.NOT_AUTHRIZED;
    case 404:
      return message || MESSAGES.NOT_FOUND;
    case 500:
      return message || MESSAGES.ERROR;

    default:
      return message || MESSAGES.ERROR;
  }
};

export const errorHandler = (err: any): ResponseError => {
  return {
    status: err?.response?.status || 500,
    message: getMessage(
      err?.response?.status,
      err?.response?.data?.titulo || err.response?.data?.message
    ),
  };
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
export const baseURL = process.env.REACT_APP_API_URL;
export default api;
